"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "majano": {
    "6c896790": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "skipSearch": false
    }],
    "comerzo": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a52c525": [{
      "hkey": "7c402491",
      "slug": "san-tomaso",
      "name": "San Tomaso",
      "primary": true,
      "skipSearch": false
    }],
    "san-tommaso": [{
      "hkey": "7c402491",
      "slug": "san-tomaso",
      "name": "San Tomaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2440dcaa": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "skipSearch": false
    }],
    "susans": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "majano"
    }],
    "1f42bf9f": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "skipSearch": false
    }],
    "tiveriacco": [{
      "hkey": "fe6766fc",
      "slug": "comerzo-susans-tiveriacco",
      "name": "Comerzo-Susans-Tiveriacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "majano"
    }]
  }
};
exports["default"] = _default;